document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector(".ugc-videos-section");
  if (!section) return;

  const videoCards = section.querySelectorAll(".ugc-video-card");
  const lightbox = section.querySelector(".ugc-lightbox");
  const lightboxVideoWrap = lightbox.querySelector(".ugc-lightbox__video");
  const lightboxProducts = lightbox.querySelector(".ugc-lightbox__products");
  const closeTargets = lightbox.querySelectorAll("[data-ugc-close]");
  const miniVideo = section.querySelector(".ugc-mini-video");
  const miniContent = miniVideo ? miniVideo.querySelector(".ugc-mini-video__content") : null;
  const miniClose = miniVideo ? miniVideo.querySelector(".ugc-mini-video__close") : null;

  let currentHoverVideo = null;
  let lightboxActiveVideo = null;

  // Utility: pause every HTML5 video in the section except an optional one
  const pauseAll = (except) => {
    section.querySelectorAll("video").forEach(v => {
      if (v !== except) {
        try { v.pause(); } catch(e) {}
      }
    });
  };

  // OPEN LIGHTBOX
  const openLightbox = (videoEl, products = []) => {
    pauseAll(videoEl);

    lightboxVideoWrap.innerHTML = "";
    lightboxProducts.innerHTML = "";

    let playable;
    if (videoEl.tagName.toLowerCase() === "video") {
      playable = videoEl.cloneNode(true);
      playable.controls = true;
      playable.muted = false;
      playable.autoplay = true;
      playable.playsInline = true;
      playable.currentTime = 0;
    } else {
      playable = videoEl.cloneNode(true);
    }
    lightboxVideoWrap.appendChild(playable);
    lightboxActiveVideo = playable;

    // Render products
    if (Array.isArray(products) && products.length) {
      products.forEach(p => {
        const a = document.createElement("a");
        a.href = p.url;
        a.setAttribute("aria-label", p.title);
        a.innerHTML = `
          <img src="${p.featured_image}" alt="${p.title}">
          <div class="ugc-lightbox__product-info">
            <span class="ugc-lightbox__product-title">${p.title}</span>
            <span class="ugc-lightbox__product-price">${p.price ?? ""}</span>
          </div>
        `;
        lightboxProducts.appendChild(a);
      });
      lightboxProducts.style.display = "grid";
    } else {
      lightboxProducts.style.display = "none";
    }

    lightbox.hidden = false;
    document.documentElement.classList.add("ugc-no-scroll");
    document.body.classList.add("ugc-no-scroll");

    const content = lightbox.querySelector(".ugc-lightbox__content");
    if (content) content.focus();
  };

  // CLOSE LIGHTBOX
  const closeLightbox = ({ toMini = true } = {}) => {
    if (toMini && miniVideo && lightboxActiveVideo) {
      miniVideo.hidden = false;
      miniContent.innerHTML = "";
      miniContent.appendChild(lightboxActiveVideo);
      try {
        lightboxActiveVideo.controls = true;
        lightboxActiveVideo.pause();
      } catch (e) {}
    } else {
      if (lightboxActiveVideo && lightboxActiveVideo.pause) {
        try { lightboxActiveVideo.pause(); } catch(e) {}
      }
      lightboxActiveVideo = null;
    }

    lightbox.hidden = true;
    document.documentElement.classList.remove("ugc-no-scroll");
    document.body.classList.remove("ugc-no-scroll");

    setTimeout(() => {
      lightboxVideoWrap.innerHTML = "";
    }, 50);
  };

  // Hover play logic
  videoCards.forEach(card => {
    const html5 = card.querySelector("video");
    const iframe = card.querySelector("iframe");
    const mediaEl = html5 || iframe;
    if (!mediaEl) return;

    card.addEventListener("mouseenter", () => {
      card.classList.add("hovered");
      if (html5) {
        if (currentHoverVideo && currentHoverVideo !== html5) {
          currentHoverVideo.pause();
          currentHoverVideo.closest(".ugc-video-card")?.classList.remove("hovered");
        }
        html5.muted = true;
        html5.play().catch(() => {});
        currentHoverVideo = html5;
      }
    });

    // Keep playing until another hover
  });

  // Card click → open lightbox
  section.querySelector(".ugc-videos__list")?.addEventListener("click", (e) => {
    const card = e.target.closest(".ugc-video-card");
    if (!card) return;

    // Ignore clicks on arrows
    if (e.target.closest(".slider-button")) return;

    let products = [];
    try {
      products = JSON.parse(card.dataset.products || "[]");
    } catch (_) {}

    const mediaEl = card.querySelector("video, iframe");
    if (mediaEl) openLightbox(mediaEl, products);
  });

  // Play button forwards to card click
  section.querySelectorAll(".ugc-video-card__play").forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      btn.closest(".ugc-video-card")?.click();
    });
  });

  // Close handlers
  closeTargets.forEach(el => {
    el.addEventListener("click", () => closeLightbox({ toMini: true }));
  });

  // Esc key
  document.addEventListener("keydown", (e) => {
    if (!lightbox.hidden && (e.key === "Escape" || e.key === "Esc")) {
      closeLightbox({ toMini: true });
    }
  });

  // Mini video close
  if (miniClose && miniVideo) {
    miniClose.addEventListener("click", () => {
      miniVideo.hidden = true;
      const v = miniContent.querySelector("video, iframe");
      if (v && v.pause) {
        try { v.pause(); } catch(e) {}
      }
      miniContent.innerHTML = "";
      lightboxActiveVideo = null;
    });
  }

  /* ===== Slider driver ===== */
  function initUGCSlider(rootEl) {
    const slider = rootEl.querySelector("[data-ugc-slider]");
    const prev   = rootEl.querySelector("[data-ugc-prev]");
    const next   = rootEl.querySelector("[data-ugc-next]");
    if (!slider || !prev || !next) return;

    const getStep = () => {
      const card = slider.querySelector(".ugc-video-card");
      if (!card) return slider.clientWidth;
      const styles = getComputedStyle(slider);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);
      return card.getBoundingClientRect().width + gap;
    };

    const goLeft  = (e) => { e.stopPropagation(); slider.scrollBy({ left: -getStep(), behavior: "smooth" }); };
    const goRight = (e) => { e.stopPropagation(); slider.scrollBy({ left:  getStep(), behavior: "smooth" }); };

    prev.addEventListener("click", goLeft);
    next.addEventListener("click", goRight);
  }

  // Init sliders
  document.querySelectorAll(".ugc-videos__carousel").forEach(initUGCSlider);

  document.addEventListener("shopify:section:load", (ev) => {
    const root = ev.target.querySelector(".ugc-videos__carousel");
    if (root) initUGCSlider(root);
  });
});
